<template>
  <WdsStack
    :direction-row="!fullWidth"
    :direction-column="fullWidth"
    justify-space-between
    :align-start="!alignCenter"
    :align-center="alignCenter"
    gap-md
  >
    <WdsStack
      direction-column
      :class="{
        'tw-w-6/12': !fullWidth,
        'tw-w-full': fullWidth,
      }"
    >
      <slot name="label">
        <WdsStack direction-row gap-sm items-center>
          <WdsText v-if="label" primary large>{{ label }}</WdsText>

          <div>
            <WdsTag v-if="optional" sm>{{ $t('Optional') }}</WdsTag>
          </div>
        </WdsStack>
      </slot>

      <slot name="helperText">
        <WdsText v-if="helperText" secondary>{{ helperText }}</WdsText>
      </slot>
    </WdsStack>

    <div
      class="tw-flex"
      :class="{
        'tw-justify-end tw-w-6/12': !fullWidth,
        'tw-w-full': fullWidth,
      }"
    >
      <slot />
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsTag, WdsText } from '@worksome/wds-components'

import { $t } from '@/composables/translation'

defineProps({
  label: {
    type: String,
    required: false,
    default: null,
  },

  helperText: {
    type: String,
    required: false,
    default: null,
  },

  fullWidth: {
    type: Boolean,
    default: false,
  },

  alignCenter: {
    type: Boolean,
    default: false,
  },

  optional: {
    type: Boolean,
    default: false,
  },
})
</script>
